import { Colors } from 'libs/ui/theme';

import { SvgIcon } from '../SvgIcon';
import { SvgProps } from '../types';

export const Repeat = ({
  size = 24,
  color = Colors.black,
  className,
}: SvgProps) => (
  <SvgIcon className={className} size={size}>
    <svg
      color={color}
      fill="none"
      height="16"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9993 4H5.33268C3.85992 4 2.66602 5.19391 2.66602 6.66667V7.33333M3.99935 12.6667H10.666C12.1388 12.6667 13.3327 11.4728 13.3327 10V9.33333M11.3327 6L12.8613 4.4714C13.1216 4.21106 13.1216 3.78895 12.8613 3.5286L11.3327 2M4.66602 10.6667L3.13742 12.1953C2.87707 12.4556 2.87707 12.8777 3.13742 13.1381L4.66602 14.6667"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
    </svg>
  </SvgIcon>
);
